var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEverstart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1159_3592)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#8A79FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1159_3592)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6973 10.4167V29.8602H39.5833V10.4167H21.6973ZM21.6973 10.417L21.6794 10.4167C15.4591 10.4167 10.4166 14.7694 10.4166 20.1388C10.4166 25.5083 15.4591 29.8611 21.6794 29.8611L21.6973 29.8608V10.417Z",
    fill: "url(#paint0_linear_1159_3592)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3027 20.1389V39.5824H10.4166V20.1389H28.3027ZM28.3027 20.1389H28.3205C34.5408 20.1389 39.5833 24.4917 39.5833 29.8611C39.5833 35.2305 34.5408 39.5833 28.3205 39.5833L28.3027 39.5832V20.1389Z",
    fill: "url(#paint1_linear_1159_3592)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5833 29.8602C39.5827 24.4912 34.5404 20.1389 28.3205 20.1389L28.3027 20.139V20.1389H21.6973H10.4166C10.4167 25.5084 15.4592 29.8611 21.6794 29.8611L21.6973 29.8608V29.8602H28.3027H39.5833Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_3592",
    x1: 10.4126,
    y1: 20.1367,
    x2: 39.5873,
    y2: 20.1367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1159_3592",
    x1: 10.4126,
    y1: 29.8589,
    x2: 39.5873,
    y2: 29.8589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1159_3592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1159_3592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.1667,
    height: 29.1667,
    fill: "white",
    transform: "translate(10.4166 10.4167)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverstart);
export default __webpack_public_path__ + "static/media/everstart.17f73fd0f6796e652ee1b62c026f69ec.svg";
export { ForwardRef as ReactComponent };